// extracted by mini-css-extract-plugin
export default {"header":"ProgramDetailsSection_header__tPmpP","paper":"ProgramDetailsSection_paper__OkCs-"};